import React from 'react';
import classnames from 'classnames';

import * as styles from './Label.module.css';

export function Label({htmlFor, children, fontWeight = 'bold'}) {
  const labelClasses = classnames(
    styles.Label,
    styles[`FontWeight-${fontWeight}`],
  );

  return (
    <label htmlFor={htmlFor} className={labelClasses}>
      {children}
    </label>
  );
}
